import { ItemInstance } from '@headless-tree/core';
import Typography from '@mui/material/Typography';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { ChevronLeft } from 'shared/assets/icons';
import { Colors, IconButton } from 'shared/components/ui/icon-button';
import { InternalTreeItem } from 'shared/components/ui/virtualized-tree-list';
import { DayPartSections } from 'shared/types/page-sections';

import * as Styled from './day-part-header.style';

export type DayPartHeaderProps = {
  item: ItemInstance<InternalTreeItem>;
  denseFormat?: boolean;
};

export const DayPartHeader: React.FC<DayPartHeaderProps> = ({
  item,
  denseFormat,
}) => {
  const { t } = useTranslation();
  const dayPartId = item.getItemData()?.sourceId as DayPartSections;

  const toggleOpen = (e: React.MouseEvent) => {
    e.stopPropagation();
    item.isExpanded() ? item.collapse() : item.expand();
  };

  return (
    <Styled.HeaderContainer $denseFormat={!!denseFormat}>
      <Typography variant="h6" component="span">
        {t(
          dayPartId === DayPartSections.Overdue
            ? 'general.sections.overdue.title'
            : `general.sections.day-part.${dayPartId}.title`,
        )}
      </Typography>

      <IconButton
        icon={ChevronLeft}
        onClick={toggleOpen}
        rotation={item.isExpanded() ? -90 : 0}
        color={Colors.Default}
      />
    </Styled.HeaderContainer>
  );
};
